/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useEffect } from "react";

type MouseEventType = "mousemove" | "mouseup";
// Hook to add a mouseevent listener of a given type
export function useMouseEvent(type: MouseEventType, handler: (event: MouseEvent) => void): void {
  useEffect(
    () => {
      const listener = (event: any) => {
        handler(event);
      };

      document.addEventListener(type, listener);

      return () => {
        document.removeEventListener(type, listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [handler]
  );
}
